import * as React from "react";
import type { SVGProps } from "react";
const Component = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M35.8124 36.371V9.83877H33.8078L29.2917 4.75806H26.2157V2.5H4.19934V36.371H3.07031V37.5H15.4897H17.7477H22.2639H23.3929H27.909H29.0381H33.5542H35.8122H36.9413V36.371H35.8124ZM28.7853 5.8871L32.297 9.83877H26.2155V8.14516H25.0865V9.83877H19.005L22.518 5.8871H28.7853ZM18.8769 7.58071V6.45167H20.505L19.5013 7.58071H18.8769ZM15.4897 36.371H9.28005V27.9032H15.4898V36.371H15.4897ZM15.4897 21.1291H13.2316V20.0001H15.4897V21.1291ZM15.4897 16.613H13.2316V15.4839H15.4897V16.613ZM15.4897 12.0968H13.2316V10.9678H15.4897V12.0968ZM12.1026 9.83877V13.2259H15.4897V14.3549H12.1026V17.742H15.4897V18.871H12.1026V22.2581H15.4897V24.5162H6.45741V25.6452H15.4897V26.7743H6.45741V27.9033H8.15102V36.3711H5.32838V3.62903H25.0865V4.75806H22.0105L21.5086 5.32264H17.7479V8.70974H18.4981L17.4945 9.83877H16.6189H15.4899H12.1026ZM21.1349 36.371H18.8769V32.9839C18.8769 32.3612 19.3833 31.8548 20.0059 31.8548C20.6285 31.8548 21.1349 32.3612 21.1349 32.9839V36.371ZM26.7801 36.371H24.522V32.9839C24.522 32.3612 25.0285 31.8548 25.6511 31.8548C26.2737 31.8548 26.7801 32.3612 26.7801 32.9839V36.371ZM32.4253 36.371H30.1672V32.9839C30.1672 32.3612 30.6736 31.8548 31.2962 31.8548C31.9189 31.8548 32.4253 32.3612 32.4253 32.9839V36.371ZM34.6833 36.371H33.5543V32.9839C33.5543 31.7385 32.5416 30.7258 31.2962 30.7258C30.0509 30.7258 29.0382 31.7385 29.0382 32.9839V36.371H27.9091V32.9839C27.9091 31.7385 26.8964 30.7258 25.6511 30.7258C24.4057 30.7258 23.393 31.7385 23.393 32.9839V36.371H22.264V32.9839C22.264 31.7385 21.2513 30.7258 20.0059 30.7258C18.7605 30.7258 17.7479 31.7385 17.7479 32.9839V36.371H16.6188V22.2581V18.871V17.742V14.3549V13.2259V10.9678H34.6833V36.371Z"
      fill="black"
      stroke="black"
      strokeWidth="0.00035"
    />
    <path
      d="M22.2583 25.6453H17.7422V29.0324H22.2583V25.6453ZM21.1293 27.9033H18.8712V26.7743H21.1293V27.9033Z"
      fill="#007A3F"
      stroke="black"
      strokeWidth="0.00035"
    />
    <path
      d="M27.9068 25.6453H23.3906V29.0324H27.9068V25.6453ZM26.7777 27.9033H24.5197V26.7743H26.7777V27.9033Z"
      fill="#007A3F"
      stroke="black"
      strokeWidth="0.00035"
    />
    <path
      d="M33.5474 25.6453H29.0312V29.0324H33.5474V25.6453ZM32.4183 27.9033H30.1603V26.7743H32.4183V27.9033Z"
      fill="#007A3F"
      stroke="black"
      strokeWidth="0.00035"
    />
    <path
      d="M22.2583 21.1289H17.7422V24.516H22.2583V21.1289ZM21.1293 23.387H18.8712V22.2579H21.1293V23.387Z"
      fill="#007A3F"
      stroke="black"
      strokeWidth="0.00035"
    />
    <path
      d="M27.9068 21.1289H23.3906V24.516H27.9068V21.1289ZM26.7777 23.387H24.5197V22.2579H26.7777V23.387Z"
      fill="#007A3F"
      stroke="black"
      strokeWidth="0.00035"
    />
    <path
      d="M33.5474 21.1289H29.0312V24.516H33.5474V21.1289ZM32.4183 23.387H30.1603V22.2579H32.4183V23.387Z"
      fill="#007A3F"
      stroke="black"
      strokeWidth="0.00035"
    />
    <path
      d="M22.2583 16.613H17.7422V20.0001H22.2583V16.613ZM21.1293 18.8711H18.8712V17.7421H21.1293V18.8711Z"
      fill="#007A3F"
      stroke="black"
      strokeWidth="0.00035"
    />
    <path
      d="M27.9068 16.613H23.3906V20.0001H27.9068V16.613ZM26.7777 18.8711H24.5197V17.7421H26.7777V18.8711Z"
      fill="#007A3F"
      stroke="black"
      strokeWidth="0.00035"
    />
    <path
      d="M33.5474 16.613H29.0312V20.0001H33.5474V16.613ZM32.4183 18.8711H30.1603V17.7421H32.4183V18.8711Z"
      fill="#007A3F"
      stroke="black"
      strokeWidth="0.00035"
    />
    <path
      d="M22.2583 12.0967H17.7422V15.4838H22.2583V12.0967ZM21.1293 14.3547H18.8712V13.2257H21.1293V14.3547Z"
      fill="#007A3F"
      stroke="black"
      strokeWidth="0.00035"
    />
    <path
      d="M27.9068 12.0967H23.3906V15.4838H27.9068V12.0967ZM26.7777 14.3547H24.5197V13.2257H26.7777V14.3547Z"
      fill="#007A3F"
      stroke="black"
      strokeWidth="0.00035"
    />
    <path
      d="M33.5474 12.0967H29.0312V15.4838H33.5474V12.0967ZM32.4183 14.3547H30.1603V13.2257H32.4183V14.3547Z"
      fill="#007A3F"
      stroke="black"
      strokeWidth="0.00035"
    />
    <path
      d="M6.45312 22.2582H10.9693V18.8711H6.45312V22.2582ZM7.58216 20.0001H9.84022V21.1292H7.58216V20.0001Z"
      fill="#007A3F"
      stroke="black"
      strokeWidth="0.00035"
    />
    <path
      d="M6.45312 17.7418H10.9693V14.3547H6.45312V17.7418ZM7.58216 15.4838H9.84022V16.6128H7.58216V15.4838Z"
      fill="#007A3F"
      stroke="black"
      strokeWidth="0.00035"
    />
    <path
      d="M6.45312 13.226H10.9693V9.83887H6.45312V13.226ZM7.58216 10.9679H9.84022V12.0969H7.58216V10.9679Z"
      fill="#007A3F"
      stroke="black"
      strokeWidth="0.00035"
    />
    <path
      d="M6.45312 8.70961H10.9693V5.32251H6.45312V8.70961ZM7.58216 6.45154H9.84022V7.58057H7.58216V6.45154Z"
      fill="#007A3F"
      stroke="black"
      strokeWidth="0.00035"
    />
    <path
      d="M12.1016 8.70961H16.6177V5.32251H12.1016V8.70961ZM13.2306 6.45154H15.4887V7.58057H13.2306V6.45154Z"
      fill="#007A3F"
      stroke="black"
      strokeWidth="0.00035"
    />
  </svg>
);
export default Component;
